import { Component } from "@angular/core";
import { SpaceService } from "src/app/_services/space.service";
import { SpaceType } from "src/app/_types/space-type";

@Component({
  selector: "app-room-details",
  templateUrl: "./room-details.page.html",
  styleUrls: ["./room-details.page.scss"],
})
export class RoomDetailsPage{
  spaceType: SpaceType = SpaceType.Room;

  constructor(
    private spaceServ: SpaceService,
  ) {}

  ionViewDidLeave() {
    this.spaceServ.assignmentList = [];
    this.spaceServ.equipmentList = [];
  }
}
